import SelectableCard from '@/components/SelectableCard/SelectableCard';
import { ProductVariant } from '@/contentful/api/types';
import useGlobalStyles from '@/styles/global.styles';

import useStyles from './EcommOptionsList.styles';

interface EcommOptionsListProps {
  variants?: ProductVariant[];
  selectedVariantId: string;
  setSelectedVariantId: (id: string) => void;
}

const EcommOptionsList: React.FC<EcommOptionsListProps> = ({
  variants,
  selectedVariantId,
  setSelectedVariantId,
}) => {
  const { classes } = useStyles();
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });
  return (
    <div role='radiogroup' aria-label='Options'>
      <h4 className={globalClasses.h4}>Options</h4>
      <div className={classes.options}>
        {variants?.map(({ id, title }) => (
          <SelectableCard
            key={id}
            name='options'
            value={id}
            isSelected={selectedVariantId === id}
            onSelect={() => setSelectedVariantId(id)}
            ariaLabel={title}
          >
            <div className={classes.selectableCardContent}>{title}</div>
          </SelectableCard>
        ))}
      </div>
    </div>
  );
};

export default EcommOptionsList;
